// extracted by mini-css-extract-plugin
export default {"container":"mr-z","heading":"nr-z","text":"or-z","info":"pr-z","link":"qr-z","fullMaxWidth":"rr-z"};